export enum Theme {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum UserLanguage {
  ZH_CN = 'zh-CN',
  ZH_HK = 'zh-HK',
  EN_US = 'en-US',
}

export type UserPermission =
  | 'SAAS_ADMIN'
  | 'AMI'
  | 'WEALTHLINK'
  | 'OPENAPI'
  | 'ORG_ADMIN'
  | 'SPREADI'
  | 'SPREADI2'
  | 'MDA'
  | 'CSR_RECORD'
  | 'ESG_RATING'
  | 'ESG_HUB'
  | 'CARBON_LENS'
  | 'EHS';

export enum AuthType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export interface User {
  name: string;
  id: string;
  permissions: UserPermission[];
  userId: string | null;
  email: string | null;
  basic: any;
  organization: any;
  basicInfo: {
    userId: string | null;
    organization: string | null;
    email: string | null;
    alias: string | null;
    prefix: string | null;
    firstName: string | null;
    middleName: string | null;
    lastName: string | null;
    phone: string | null;
    address: string | null;
    region: string | null;
    activated: boolean;
    language: string | null;
    userRoleId: number | null;
    userRole: string | null;
  };
  userRoles: {
    userRoleId: number;
    userRoleName: string;
  }[];
  userGroup: {
    userRoleId: number;
    userRoleName: string;
  };
  apps: any;
  appGroups: any;
  appDetails: any;
  accessibleApps: any;
  preference: {
    userId: string;
    organization: string;
    currency: string;
    language: UserLanguage;
    googleTranslationOn: boolean;
    enableAnnouncement: boolean;
  };
  trialEnabled: boolean;
  performanceAdditionalCharts: string[];
  analysisRoomTools: string[];
  pdfReportSections: string[];
  companyLogoUrl: string;
  pdfReportLogoUrl: string;
  subscription: string;
  portxAdditionalReportTemplates: string[];
  p: any;
  permissionMap: {
    [K in UserPermission]?: boolean;
  };
  accessibleAppMap: any;
  applications: any;
  roles: string[];
  appHostMap: any;
  appHostUrls: any;
  set: any;
  authType: AuthType;
}

export enum SupportedBrowsers {
  CHROME = 'CHROME',
  IE11 = 'IE11',
  EDGE = 'EDGE',
  HEADLESS = 'HEADLESS',
}

export type I18nResource = {
  [k in UserLanguage]?: {
    [k: string]: string;
  };
};

export interface I18nObject {
  [k: string]: any;
}

declare global {
  interface Window {
    __config__: any;
    __user__: User;
    chrome: any;
    opr: any;
  }
}
